import React from "react";
import { GrAccessibility } from "react-icons/gr";
import { ImMagicWand } from "react-icons/im";
import { GiRock } from "react-icons/gi";
import { IconContext } from "react-icons/lib";
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardCost,
  PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature,
} from "./Pricing.elements";

function Pricing() {
  return (
    <IconContext.Provider value={{ color: "#fff", size: 64 }}>
      <PricingSection>
        <PricingWrapper>
          <PricingHeading>Our Services</PricingHeading>
          <PricingContainer>
            <PricingCard>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiRock />
                </PricingCardIcon>
                <PricingCardPlan>Problem Solving</PricingCardPlan>
                <PricingCardCost></PricingCardCost>
                <PricingCardLength></PricingCardLength>
                <PricingCardFeatures>
                  <PricingCardFeature>
                    Serbeat LLC aims to offer
                  </PricingCardFeature>
                  <PricingCardFeature>
                    innovative solutions for Serbian
                  </PricingCardFeature>
                  <PricingCardFeature>
                    producers entering the market
                  </PricingCardFeature>
                </PricingCardFeatures>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GrAccessibility />
                </PricingCardIcon>
                <PricingCardPlan>Communication</PricingCardPlan>
                <PricingCardCost></PricingCardCost>
                <PricingCardLength></PricingCardLength>
                <PricingCardFeatures>
                  <PricingCardFeature>Focusing on more than</PricingCardFeature>
                  <PricingCardFeature>one type of marketing</PricingCardFeature>
                  <PricingCardFeature>
                    communication and sales
                  </PricingCardFeature>
                </PricingCardFeatures>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard>
              <PricingCardInfo>
                <PricingCardIcon>
                  <ImMagicWand />
                </PricingCardIcon>
                <PricingCardPlan>Sales Methods</PricingCardPlan>
                <PricingCardCost></PricingCardCost>
                <PricingCardLength></PricingCardLength>
                <PricingCardFeatures>
                  <PricingCardFeature>
                    We provide our members
                  </PricingCardFeature>
                  <PricingCardFeature>
                    with all available and innovative
                  </PricingCardFeature>
                  <PricingCardFeature>
                    promotion and sales methods
                  </PricingCardFeature>
                </PricingCardFeatures>
              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
  );
}

export default Pricing;
